<template>
	<div>
		<header class="lmy-header lmy-header-w">
	        <i class="iconfont icon-yuyin" @click="isLeave=true"></i>
	        去支付
	    </header>
	    <div class="lmy-order-preview">
	        <div class="order-title">订单信息</div>
	        <div class="order-info">
	            <p class="room-name">{{bookInfo.HotelName}}</p>
	            <p>入离:{{bookInfo.CheckIn|dateShort}}-{{bookInfo.CheckOut|dateShort}}  | 共{{bookInfo.days}}晚</p>
	            <p>{{bookInfo.RoomName}} | {{bookInfo.RPName}}</p>	
	            <p>补充说明: {{bookRequest.SpecialRequest||'无'}}</p>	

	            <div class="room-people">
	       
	                 <div class="people" >
	                    <div class="room-people-title" :style="'height:'+0.89*bookRequest.Guests.length+'rem'+';line-height:'+0.89*bookRequest.Guests.length+'rem'">入住人</div>
	                    <div class="room-people-content" v-for="person in bookRequest.Guests">
	                        <div class="room-people-input">{{person.LastName}}{{person.FirstName}}</div>
	                    </div>
	                </div>
	                <div class="tel">
	                    <div class="room-tel-title">联系电话</div>
	                    <div class="room-tel-content">{{bookRequest.Phone}}</div>
	                </div>
	           
	            </div>
	        </div>
	        <div class="order-pay">
	            <div class="order-item" v-if="!bookRequest.newPrice">
	            	<label class="item-title">应付总额</label>

	            	<div class="item-body">
	            		¥
	            		<!-- <span class="order-first-discount" v-if="bookRequest.Amount">{{bookInfo.AdultPrice*bookInfo.RoomCount}}.0</span> -->
	            		<span v-if="bookRequest.Amount">{{(bookInfo.AdultPrice*bookInfo.RoomCount)-bookRequest.Amount}}</span>
	            		<span v-if="!bookRequest.Amount">{{bookInfo.AdultPrice*bookInfo.RoomCount}}</span>
	            	</div>
	            </div>
				<div class="order-item" v-else>
	            	<label class="item-title">应付总额</label>
	            	<div class="item-body">
	            		¥
	            		<span>{{bookRequest.newPrice}}</span>
	            	</div>
	            </div>
	        </div>
	        <div class="order-title">支付方式</div>
	        <div class="pay-type">
	            <div class="wx-pay">
	                <div class="logo">
	                    <img src="./../../assets/img/wx.png" alt="">
	                </div>
	                微信支付
	            </div>
	            <i class="iconfont icon-check"></i>
	        </div>
					<div class="room-people-toast">
	        	由于价格变动频繁,请在10分钟内完成支付
	        	<!-- <i class="iconfont icon-guanbi"></i> -->
	        </div>

	        <div class="lmy-select-btn" @click="book">去支付</div>
	    </div>
	   	<div class="cmpnt-modal-box" v-if="isLeave">
			<div class="lmy-mask-s"></div>
		    <div class="lmy-modal">
		        <div class="lmy-modal-head">提示</div>
		        <div class="lmy-modal-body">
		            <p>支付尚未完成 ,确定要离开？</p>
		        </div>
		        <div class="lmy-modal-foot">
		            <div class="sort-btn" onclick="window.history.go(-1)">离开</div>
		            <div class="sort-btn" @click="isLeave=false">继续支付</div>
		        </div>
		    </div>	
	    </div>	
	    <div class="book-comfirming" v-if="isSubmit">
		    <div class='f-modal' >
	            <div class='f-modal-head'>提示</div>
	            <div class='f-modal-body'>
	                <p>正在提交订单，请稍候</p>
	            </div>
	        </div>
	    </div>
	</div>
</template>
<script>
	export default{
		name:'book-comfain',
		data(){
			return{
				bookInfo:JSON.parse(this.dao.get('bookInfo')),
				bookRequest:JSON.parse(this.dao.get('bookRequest')),
				isLeave:false,
				isSubmit:false,
				promotions:''
			}
		},
		methods:{
			book(param){
 		 		var that=this;
				var params=this.bookRequest;
				  
 		 		var param={
					SpecialRequest:params.SpecialRequest,
					Guests:params.Guests,
					Phone:params.Phone,
					Token:params.Token,
					PromotionsToken:params.PromotionsToken,
					IsInvoice:params.IsInvoice,
					Invoices:params.Invoices
				}
 		 		that.isSubmit=true;

 		 		that.postRequest({
						url:that.Api.createBook, 
						params:param
					}).then(res => {
						
					    if(res&&res.IsSuccess){
					    	that.OrderNO=res.Result.MainOrderID;
					    	that.dao.set('thisBookingOrderNO',res.Result.MainOrderID);
								that.isSubmit=false;
					 			this.$router.replace({ path: '/wxPay',query:{OrderNO:this.OrderNO,flag:true}});
								if(this.dao.get('bookInfo')){
									that.isSubmit=false;
									this.dao.remove('hotelCoupon')
								}
					    }else if(!res.IsSuccess){
								that.isSubmit=false;
								this.error({title:'提示',content:res.Msg});
					    }
				});
 		 	},
			getPromotions(){
 		 		var that=this;
 		 		var param=this.bookRequest;
 		 	
 		 		that.getRequest({
						url:that.Api.getPromotions
					}).then(res => {
					
					    if(res&&res.IsSuccess){
					    	that.promotions=res;
					    	
					    }else if(!res.IsSuccess){
							this.error({title:'提示',content:res.Msg});
					    }
				});
 		 	}
 		 },
		mounted(){
			// this.getPromotions();

			
		}
	}
	
</script>


// WEBPACK FOOTER //
// src/components/book/bookComfain.vue